import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExamInstructionToggleService {
  private toggleExamInstuctionModalSubject = new Subject<void>();

  toggleExamInstuctionModal$ = this.toggleExamInstuctionModalSubject.asObservable();

  constructor() { }
  
  toggle() {
    this.toggleExamInstuctionModalSubject.next();
  }
}